import { NeutralColors, DefaultPalette } from '@fluentui/react';
import { IconErrorColor, ClickChangeType } from '../constants';

const DarkBlack = '#1A1A1A';
const DarkGrey = '#616161';
const opaqueLightWhite = 'rgb(0, 0, 0, 0.1)';

export const getTooltipCardStyles = () => ({
  '& .tooltip-card-container': {
    padding: '6px 10px 6px 10px',
    borderRadius: 4,
    width: 281,
    fontFamily: 'Segoe UI',
    whiteSpace: 'break-spaces',
  },
  '& .budget-center-tooltip-card-section': {
    paddingTop: 12,
    marginTop: 12,
    borderTop: `1px solid ${opaqueLightWhite}`,
  },
  '& .budget-center-tooltip-card-section-header': {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '20px',
    color: NeutralColors.gray160,
    marginBottom: 12,
  },
  '& .budget-center-tooltip-card-key-data-section': {
    borderTop: 'none',
    paddingTop: 0,
    marginTop: 0,
  },
  '& #hourly-trend-chart': {
    height: 100,
  },
  '& .budget-center-tooltip-section-content-item': {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: 14,
    color: DarkBlack,
    lineHeight: '20px',
    margin: '12px 0',
  },
  '& .budget-center-tooltip-item-key': {
    fontWeight: 400,
    width: 192,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  '& .budget-center-tooltip-item-value': {
    fontWeight: 700,
  },
  '& .budget-center-tooltip-section-event-item': {
    color: NeutralColors.gray160,
    lineHeight: '20px',
    marginTop: 12,
  },
  '& .budget-center-tooltip-event-message': {
    fontWeight: 700,
    fontSize: 14,
  },
  '& .budget-center-tooltip-event-hint': {
    color: DarkGrey,
    display: 'flex',
    flexDirection: 'row',
  },
  [`& .${ClickChangeType.Increase}`]: {
    color: DefaultPalette.green,
    marginRight: 4,
  },
  [`& .${ClickChangeType.Decrease}`]: {
    color: IconErrorColor,
    marginRight: 4,
  },
});
